$(() => {
  $(window).on("load", bannerView);

  $(window).on(
    "scroll",
    throttle(function () {
      bannerView();
    }, 10)
  );

  // Add smooth scrolling on all links inside the navbar
  $("#menu-main-menu li a").on("click", function (e) {
    e.preventDefault();
    const linkval = $(this).attr("href");
    const removeHash = linkval.replace("#", "");
    $(".bs-section--scroll-enable").each(function () {
      const sectionId = $(this).attr("id");
      if (removeHash === sectionId) {
        $("html, body").animate(
          {
            scrollTop: $("#" + sectionId).offset().top,
          },
          700
        );
      }
    });
  });

  $(".scroll-footer-down-btn").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: $(".footer").offset().top,
      },
      700
    );
  });
});

//Trigger Viewport
(function ($) {
  $.fn.visible = function (partial) {
    let $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;
    return compareBottom <= viewBottom && compareTop >= viewTop;
  };
})(jQuery);

//Adding class to Body
const bannerView = () => {
  $(".bs-section--main-banner").each(function (i, el) {
    const elm = $(el);
    const offset = 60; // data offset used in body tag(header.php)
    if ($(window).scrollTop() >= elm.outerHeight() - offset) {
      $("body").removeClass("bannerView");
    } else {
      $("body").addClass("bannerView");
    }
  });
};

//throttle function
function throttle(func, timeFrame) {
  let lastTime = 0;
  return function (...args) {
    let now = new Date();
    if (now - lastTime >= timeFrame) {
      func(...args);
      lastTime = now;
    }
  };
}